/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { ChangePasswordWidgetContext } from './change-password-base';
import { iamLogin } from '../main';
import { WidgetElements } from '../elements/widget-elements-base';
import { iam } from '../iam';

export class PasswordResetWidgetContext extends ChangePasswordWidgetContext {
  constructor(elements: WidgetElements) {
    super(elements, 'password-reset');
  }

  public override localize() {
    iamLogin.localizeElement('main-header', 'passwordResetMcafee');
    iamLogin.localizeElement('sub-head-link', { stringKey: 'notUserSubhead', stringParameters: { email: iamLogin.parseQuery(iam.Token.getLocation().search).login } });
  }

  public override setInitialFocus() {
    const field = this.elements.getNewPasswordField();
    if (field && !field.disabled) {
      field.focus();
    }
  }

  public override validateForm() {
    // disable submit button if either password field is blank or isn't showing all the "good" icons
    this.elements.getSubmitButton().disabled = this.elements.getNewPasswordField().value.length === 0 ||
      this.elements.getConfirmPasswordField().value.length === 0 ||
      Array.from(document.querySelectorAll<HTMLElement>('.status-icon.status-good')).some(icon => {
        return icon.style.display === 'none';
      });
  }
}
